'use client';

import { useToastContext } from '@/core/providers/ToastProvider';

export function useToast() {
  return useToastContext();
}
